<template>
    <div :style="{'max-width': '100%', 'width': '95%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">

        <div style="width: 100%; padding: 10px; font-size: 25px; background-color: #efefef;">ISSUE REFUNDS</div>
        <b-card>
            <div style="display: block;">
                <b-form @submit="search_invoice">
                    <div style="max-width: 400px; width: 100%; display: inline-block; vertical-align: top;"><b-form-input size="md" placeholder="SEARCH INVOICE" v-model="search_txt"></b-form-input></div>
                    <div style="display: inline-block; vertical-align: top;" class="mt-2 mt-md-0"><b-button type="submit" variant="primary">SEARCH</b-button></div>

                </b-form>
            </div>

            <div style="display: block; margin-top: 10px; max-height: 600px; overflow-y: scroll; min-height: 200px;" v-if="invoice_selected==false">
                <div v-if="items_being_loaded == true">
                    <loading :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                    </loading>
                </div>

                <div v-else-if="items_being_loaded == false">
                    <div v-if="search_results.length > 0">
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="srr" style="min-width: 100px;">SALE DATE</td>
                                    <td class="srr" style="min-width: 100px;">INVOICE #</td>
                                    <td class="srr" style="min-width: 100px;">CUSTOMER NAME</td>
                                    <td class="srr" style="min-width: 100px;">CUSTOMER PHONE</td>
                                    <td class="srr" style="min-width: 100px;">CUSTOMER EMAIL</td>
                                    <td class="srr" style="min-width: 100px;">CUSTOMER ZIPCODE</td>
                                    <td class="srr" style="min-width: 150px;">SOLD FROM</td>
                                    <td class="srr" style="min-width: 100px;">ACTION</td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="sr,sridx in search_results" v-bind:key="sridx">
                                    <td class="srrv">{{sr.ts}}</td>
                                    <td class="srrv">{{sr.invoice_id}}</td>
                                    <td class="srrv">{{sr.fullname}}</td>
                                    <td class="srrv">{{sr.phone}}</td>
                                    <td class="srrv">{{sr.email}}</td>
                                    <td class="srrv">{{sr.zipcode}}</td>
                                    <td class="srrv">{{packet.locsubsdict[sr.locsub]}}</td>
                                    <td class="srrv"><b-button size="sm" variant="primary" @click="get_refunds_info(sr)">SELECT</b-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-else>
                        <b-alert show variant="warning">NO INVOICE FOR THE GIVEN SEARCH KEYWORD</b-alert>
                    </div>
                </div>
            </div>

            <div v-else style="display: block; margin-top: 10px; min-height: 200px;">
                <div v-if="items_being_loaded == true">
                    <loading :active="true"
                    :can-cancel="false"
                    :is-full-page="false"

                    >
                    </loading>
                </div>
                <div v-else-if="items_being_loaded == false">
                    <div v-if="output">
                        <div style="display: block; margin-top: 10px; text-align: center; line-height: 10px; padding: 20px; font-weight: bold; background-color: black; color: white;">
                            <h5>REFUNDS FOR {{output.invoice_id}}</h5>
                        </div>

                        <div class="d-none d-lg-block">
                             <b-container fluid class="bv-example-row" style="width: 100%; padding: 10px;">
                                <b-row>
                                    <b-col>
                                        <b-input-group prepend="ISSUED SO FAR ($)" class="mt-3">
                                            <b-form-input :disabled="true" style="background-color: white; text-align: center; font-weight: bold; background: lightyellow;" v-model="output.sc_issued_so_far.toFixed(2)"></b-form-input>
                                        </b-input-group>
                                    </b-col>

                                    <b-col>
                                        <b-input-group prepend="USED SO FAR ($)" class="mt-3">
                                            <b-form-input :disabled="true" style="background-color: white; text-align: center; font-weight: bold; background: lightyellow;" v-model="output.used_so_far.toFixed(2)"></b-form-input>
                                        </b-input-group>
                                    </b-col>

                                    <b-col>
                                        <b-input-group prepend="AVAILABLE ($)" class="mt-3">
                                            <b-form-input :disabled="true" style="background-color: white; text-align: center; font-weight: bold; background: lightyellow; color: red;" :value="(get_remaining()|| 0.0).toFixed(2)"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </div>

                        <div style="width: 100%; padding: 10px;" class="d-block d-lg-none">
                          <div style="display: flex; gap: 20px; width: 100%;">

                            <div style="flex: 1;">
                              <label style="font-weight: bold;">ISSUED SO FAR ($):</label>
                              <input
                                disabled
                                :value="output.sc_issued_so_far.toFixed(2)"
                                style="width: 100%; text-align: center;
                                      font-weight: bold; background: lightyellow;"
                              >
                            </div>

                            <div style="flex: 1;">
                              <label style="font-weight: bold;">USED SO FAR ($):</label>
                              <input
                                disabled
                                :value="output.used_so_far.toFixed(2)"
                                style="width: 100%; text-align: center;
                                      font-weight: bold; background: lightyellow;"
                              >
                            </div>

                            <div style="flex: 1;">
                              <label style="font-weight: bold;">AVAILABLE ($):</label>
                              <input
                                disabled
                                :value="(get_remaining() || 0.0).toFixed(2)"
                                style="width: 100%; text-align: center;
                                      font-weight: bold; background: lightyellow; color: red;"
                              >
                            </div>

                          </div>
                        </div>

                        <div style="display: block; margin-top: 10px;" v-if="(output.allowance || 0.0) < 0">
                            <b-alert variant="danger" show>THIS INVOICE IS OVER PAID BY THE CUSTOMER BY THE AMOUNT OF <b>${{ (Math.abs((output.allowance || 0.0))).toFixed(2) }}</b>. PLEASE ADD THIS AMOUNT TO STORE CREDIT.

                            <b-card-text><b-button size="sm" variant="danger" @click="add_allowance_to_store_credit_wrapper">ADD ${{ (Math.abs((output.allowance || 0.0))).toFixed(2) }} TO STORE CREDIT</b-button></b-card-text>
                            </b-alert>
                        </div>

                        <div style="display: block; margin-top: 10px;">
                            <table style="width: 100%;">
                                <thead>
                                    <tr>
                                        <td class="pth" style="width: 250px;">PAYMENT METHOD</td>
                                        <td class="pth" style="width: 250px;">MAX ALLOWED</td>
                                        <td class="pth" style="width: 250px;">AMOUNT</td>
                                        <!-- <td class="pth">BREAKDOWN</td> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="pm,pmidx in output.pms" v-bind:key="pmidx" v-if="pm.pmname.toLowerCase().includes('store_credit') == false">
                                        <td class="ptd">{{pm.pmname}}</td>
                                        <td class="ptd">{{(pm.max_allowed || 0.0).toFixed(2)}}</td>
                                        <td class="ptd"><b-form-input size="md" v-model="pm.issue_amount" type="number" style="text-align: center; font-weight: bold;" v-on:keyup="validated = false"></b-form-input></td>
                                        <!-- <td class="ptd">{{pm.breakdown}}</td> -->
                                    </tr>
                                </tbody>
                            </table>

                            <div style="margin-top: 10px; margin-left: auto; text-align: center; display: block;">
                                <div v-if="validated == false">
                                    <b-button size="md" variant="danger" @click="validate_refund">VALIDATE</b-button>
                                </div>

                                <div v-else-if="validated == true">
                                    <div style="display: inline-block; width: 200px; vertical-align: top; line-height: 30px; font-weight: bold;">
                                        TOTAL REFUND: ${{(get_current_issues() || 0.0).toFixed(2)}}
                                    </div>

                                    <div style="display: inline-block; width: 200px; vertical-align: top;">
                                        <b-button size="md" variant="success"  @click="submit_refund">SUBMIT</b-button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div style="display: block; margin-top: 10px; border-top: 1px dashed;">

                            <div style="display: block; margin-top: 10px; text-align: center; line-height: 5px; padding: 10px; font-weight: bold; background-color: #5a6a7a; color: white;">
                                <h6>PREVIOUS REFUNDS</h6>
                            </div>

                            <div>
                                <table style="width: 100%;">
                                    <thead>
                                        <tr>
                                            <td class="srr" style="width: 200px;">ISSUED AT</td>
                                            <td class="srr" style="width: 200px;">ISSUED BY</td>
                                            <td class="srr" style="width: 200px;">ISSUED AMOUNT</td>
                                            <td class="srr" style="width: 350px;">PAYMENT METHODS</td>
                                            <!-- <td class="srr">ACTION</td> -->
                                        </tr>
                                    </thead>


                                    <tbody>
                                        <tr v-for="prf,prfidx in output.prevs" v-bind:key="prfidx" >
                                            <td class="srrv">{{prf.ts}}</td>
                                            <td class="srrv">{{(prf.processing_user || 'N/A')}}</td>
                                            <td class="srrv">$ {{ (prf.amount || 0.0).toFixed(2)}}</td>
                                            <td class="srrv">
                                                <div v-for="prfpm,prfpmidx in prf.payment_methods" v-bind:key="prfpmidx" v-if="prfpm.pmname.toLowerCase().includes('store_credit') == false">

                                                    <div style="padding: 5px; margin: 5px; font-size: 12px; text-align: left; background-color: #efefef;">
                                                        AMOUNT: {{(parseFloat(prfpm.issue_amount) || 0.0).toFixed(2)}} | METHOD: {{prfpm.pmname}}
                                                    </div>
                                                </div>
                                            </td>
                                            <!-- <td class="srrv"><b-button size="sm" variant="primary">VIEW & PRINT</b-button></td> -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </div>
                    <div v-else>
                        <b-alert show variant="primary">NO REFUNDS INFO AVAILABLE FOR INVOICE</b-alert>
                    </div>
                </div>


            </div>
        </b-card>

    </div>
</template>

<script>
    import _ from 'underscore'
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "IssueRefunds",
        components: {Backer,Loading},
        data: function(){
            return {
                packet: {},
                search_results: [],
                output: {},
                items_being_loaded: null,
                search_txt: null,
                invoice_selected: false,
                validated: false,
                invoice_id: null,

            }
        },
        methods: {
            // calculate_allowed_percs: function(){
            //     let denominator = 0.0;
            //     for (var i=0;i<that.output.pms.length; i++){
            //         let max_allowed = that.output.pms[i].max_allowed;
            //         denominator += max_allowed;
            //     }

            //     for (var i=0;i<that.output.pms.length; i++){
            //         let max_allowed = that.output.pms[i].max_allowed;
            //         let perc = max_allowed/perc;
            //         that.output.pms[i].perc = perc;
            //     }
            //     return

            // },
            add_allowance_to_store_credit_wrapper: function(){
                let that = this;
                this.$vex.dialog.prompt({
                    message: "ARE YOU SURE YOU WANT TO ADD $"+this.output.allowance+" TO INVOICE STORE CREDIT?",
                    placeholder: "TYPE YES OR NO",
                    className: 'vex-theme-os',
                    callback: function (value) {
                        if (value == "yes" || value == "YES"){
                            that.add_allowance_to_store_credit()
                        }
                    }
                });
            },
            add_allowance_to_store_credit: function(){
                let path = "/api/sales/add_allowance_to_store_credit/"
                let data = {"invoice_id": this.invoice_id, "allowance": Math.abs(this.output.allowance), created_by: this.packet.userDetails.username}
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        that.$bvToast.toast(
                            "SUCCESSFULLY ADDED TO STORE CREDIT AND ADJUSTED REFUNDS.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.get_refunds_info({invoice_id: that.invoice_id});
                    }

                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR ADDING STORE CREDIT TO THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            is_plus_zero: function(value) {
                return 1/value === Infinity;
            },
            is_minus_zero: function(value) {
                return 1/value === -Infinity;
            },
            get_remaining: function(){
                let available_right_now = this.output.available_right_now;
                let current_issues = this.get_current_issues();
                let final = available_right_now - current_issues;
                console.log(final)
                if (this.is_minus_zero(final) || this.is_plus_zero(final) ){
                    final = 0.0;
                }
                return final;
            },
            get_current_issues: function(){
                let current_issues = 0.0;
                for (var i=0; i<this.output.pms.length; i++){
                    let pm = this.output.pms[i];
                    let amount = (parseFloat(pm.issue_amount) || 0.0);
                    current_issues += amount;
                }

                let fixed = 2 || 0;
                fixed = Math.pow(10, fixed);
                current_issues = Math.floor(current_issues * fixed) / fixed;
                return current_issues;

            },
            validate_refund: function(){
                let errors = [];
                let available_right_now = (parseFloat(JSON.stringify(this.output.available_right_now)) || 0.0);

                for (var i=0; i<this.output.pms.length; i++){
                    let pm = this.output.pms[i];
                    let amount = (parseFloat(pm.issue_amount) || 0.0);

                    if (amount < 0.0){
                        errors.push({message: "NEGATIVE DOLLAR REFUND AMOUNTS ARE NOT ALLOWED."});
                    }
                    let max_allowed = pm.max_allowed;

                    if (amount <= max_allowed){
                        if (((available_right_now - amount) >= 0)) {
                            available_right_now -= amount;
                        }
                        else {
                            errors.push({message: "TOTAL REFUNDED IS EXCEEDING THE TOTAL AVAILABLE AMOUNT."})
                        }
                    }
                    else {
                        errors.push({message: "ANY AMOUNT CANNOT EXCEED ITS MAX ALLOWED AMOUNT."})
                    }
                }

                if (errors.length>0){
                    this.$vex.dialog.alert(
                        {message: errors[0].message}
                    );
                }
                else {
                    this.validated=true;
                }
                return
            },
            submit_refund: function(){
                let that = this;
                let path = "/api/sales/issue_sc_out/"
                let data = this.output;
                data.username = this.packet.userDetails.username;
                console.log(data)


                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        //that.output = response.data.result[0];
                        //that.calculate_allowed_percs();
                        that.$bvToast.toast(
                            "SUCCESSFULLY ISSUED REFUND.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.get_refunds_info({invoice_id: that.invoice_id});
                    }

                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR RETRIEVING THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);

            },

            get_refunds_info: function(row){
                let invoice_id = row.invoice_id;
                this.invoice_id = invoice_id;

                let data = {invoice_id: invoice_id}
                let path = "/api/sales/retrieve_sc_for_refund/"
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        that.output = response.data.result[0];
                        console.log(that.output)
                        //that.calculate_allowed_percs();

                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR RETRIEVING THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.invoice_selected = true;
                this.output = {};
                Requestor.getSyncP(path, data, this, s, f);

            },
            search_invoice: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.search_txt || this.search_txt.length <= 2){
                    this.$vex.dialog.alert(
                        {message: "PLEASE PROVIDE A VALID NAME/INVOICE #/PHONE/EMAIL"}
                    );
                    return
                }

                let data = {search_txt: this.search_txt}
                let path = "/api/sales/search_invoice_id/"
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        that.search_results = response.data.result;
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR SEARCHING THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                //console.log(data)
                this.items_being_loaded = true;
                this.invoice_selected = false;
                this.output = {};
                this.invoice_id = null;
                Requestor.getSyncP(path, data, this, s, f);
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

        }
    }
</script>

<style scoped>

    .srr {
        font-size: 14px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 14px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }


    .pth {
        font-size: 14px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .ptd {
        font-size: 14px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Sales/IssueRefunds.vue